/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const getKYCDataContext = React.createContext({});
export let kycDataMachine: any;

const MODULE_NAME = 'machines.verifyOTP';

export const useSMGetKYCData = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  kycDataMachine = createMachine(_machineConfig, {
    services,
    actions,
  });
  const [state, send] = useMachine(kycDataMachine);

  return {
    kycDataMachine,
    kycDataState: state,
    kycDataSend: send,
  };
};
